import React from "react";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		"font-family": theme.fonts.medium,
		textAlign: "center",
		color: theme.palette.colors.lightGrayishViolet,
		"letter-spacing": "2px",
	},
	top: {
		"font-size": "14px",
		"line-height": "0.71",
		color: theme.palette.colors.oneMoreGrey,
		"margin-bottom": "10px",
		textTransform: "uppercase",
	},
	bot: {
		fontFamily: theme.fonts.medium,
		"font-size": "64px",
		"line-height": "0.78",
		"text-transform": "uppercase",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			textAlign: "center",
		},
		top: {
			display: "none",
		},
		bot: {
			fontSize: "39px",
			lineHeight: "1",
			verticalAlign: "bottom",
		},
	},
});

const Component = ({ classes, text }) => {
	return (
		<div className={classes.root}>
			<div className={classes.top}>{text.DIGITAL}</div>
			<div className={classes.bot}>{text.TENDER_TV_SERVICE}</div>
		</div>
	);
};

const TV = withStyles(styles)(Component);
TV.displayName = "TV";

export default TV;
